/**
 * Notification API methods.
 */
import api from "./client";

export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string | null;
  is_read: boolean;
  related_entity_type: string | null;
  related_entity_id: string | null;
  created_at: string;
}

export const notificationApi = {
  list: (unreadOnly = false) =>
    api.get<Notification[]>("/notifications", { params: { unread_only: unreadOnly } }).then((r) => r.data),

  markRead: (id: string) => api.post(`/notifications/mark-read/${id}`).then((r) => r.data),

  markAllRead: () => api.post("/notifications/mark-all-read").then((r) => r.data),

  unreadCount: () => api.get<{ count: number }>("/notifications/unread-count").then((r) => r.data),
};